import React, { useEffect, useState } from 'react';
import { apiUrl } from '../../config/api';
import './AnnouncementBar.scss';

const AnnouncementBar = () => {
  const [announcement, setAnnouncement] = useState(null);

  useEffect(() => {
    const controller = new AbortController();

    const fetchAnnouncement = async () => {
      try {
        const response = await fetch(apiUrl('/api/announcement'), {
          method: 'GET',
          signal: controller.signal,
        });
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        if (data?.success && data.announcement) setAnnouncement(data.announcement);
      } catch (error) {
        // A missing announcement is not an error worth surfacing —
        // the bar simply does not render.
        if (error.name !== 'AbortError') setAnnouncement(null);
      }
    };

    fetchAnnouncement();
    return () => controller.abort();
  }, []);

  if (!announcement) return null;

  return (
    <aside className="announcement-bar" aria-label="Store announcement">
      {/* A single copy of the message. It enters from the right, crosses
          the bar and leaves at the left, then the cycle repeats — so the
          announcement is on screen once at a time rather than tiled. */}
      <div className="announcement-bar__track">
        <span className="announcement-bar__text">{announcement}</span>
      </div>
    </aside>
  );
};

export default AnnouncementBar;
